import Vue from "vue";
import Vuex from "vuex";
import { array, classMap, autoLoad } from "@/utils/helper";
import createMultiTabState from 'vuex-multi-tab-state';

/* Modules */
import auth from "./modules/auth";
import toggle from "./modules/toggle";
import profile from "./modules/profile";
import stepper from "./modules/stepper";
import golfcourse from "./modules/golfcourse";
import post from "./modules/post";
import location from "./modules/location";
import comment from "./modules/comment";
import follow from "./modules/follow";
import media from "./modules/media";
import interview from "./modules/interview";
import report from "./modules/report";
import player from "./modules/player";
import chat from "./modules/chat";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth,
    toggle,
    profile,
    stepper,
    golfcourse,
    post,
    location,
    comment,
    follow,
    media,
    interview,
    report,
    player,
    chat
  },
  plugins: [
    createMultiTabState({
      statesPaths: [
        'chat.friends', 
        'chat.activeChats', 
        'chat.friendsDate', 
        'chat.openedChatBoxes',
        'chat.conversationMap',
        'chat.showListFriend'
      ],
    }),
  ],
  getters: {},
  actions: {},
});
